module.exports = __webpack_public_path__ + "static/img/55.383e30bd.png";